<span class="sui-textarea__field">
  <textarea
    ngpTextarea
    class="sui-textarea__control"
    [class.sui-textarea__control--code]="code"
    [attr.spellcheck]="code ? 'false' : null"
    [attr.autocorrect]="code ? 'off' : null"
    [attr.autocapitalize]="code ? 'off' : null"
    [id]="effectiveId"
    [placeholder]="placeholder"
    [disabled]="isDisabled()"
    [readOnly]="readonly"
    [rows]="rows"
    [attr.autocomplete]="autocomplete || null"
    [attr.aria-invalid]="errorState ? 'true' : null"
    [value]="value() ?? ''"
    (input)="onInput($event)"
    (blur)="markTouched()"
  ></textarea>
  <fa-icon
    class="sui-textarea__invalid-icon"
    [icon]="faCircleExclamation"
    aria-hidden="true"
  ></fa-icon>
</span>
